module.exports = __webpack_public_path__ + "static/media/boton_jugar.274ec5ed.png";